function SessionPropertiesEvent() {
}

module.exports = SessionPropertiesEvent;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/control/session-properties-event.js
// module id = 727
// module chunks = 1